<template>
  <div>
    <!-- .option设置 -->
    <div class="table" v-loading="loading" :element-loading-text="schedule + ' / 100'"
      element-loading-spinner="el-icon-loading">
      <ol>
        <!-- 附加服务中文名 -->
        <li>
          {{ $t('message.additionalServicesChinese') }}
        </li>
        <!-- 附加服务日文名 -->
        <li>
          {{ $t('message.additionalServicesJapanese') }}
        </li>
        <!-- 收费标准 -->
        <li class="flex05">
          {{ $t('message.chargingStandards') }}
        </li>
        <!-- 计费方式 -->
        <li>
          {{ $t('message.billingWay') }}
        </li>
        <!-- 图片 -->
        <li>
          {{ $t('message.pic') }}
        </li>
        <!-- 视频 -->
        <li>
          {{ $t('message.video') }}
        </li>
        <!-- 文件 -->
        <li>
          {{ $t('message.file') }}
        </li>
        <!-- 特殊要求 -->
        <li>
          {{ $t('message.specialRequirements') }}
        </li>
        <!-- 操作 -->
        <li class="flex05">
          {{ $t('message.operation') }}
        </li>
      </ol>
      <ul v-for="(item, index) in detail.option" :key="index">
        <!-- 附加服务中文名 -->
        <li>
          <div class="template">
            <span style="margin-right: 7px;">
              {{ index + 1 }}
            </span> <el-input v-model="item.name" size="medium"></el-input>
          </div>
        </li>
        <!-- 附加服务日文名 -->
        <li>
          <div class="template">
            <el-input v-model="item.name_translate" size="medium"></el-input>
          </div>
        </li>
        <!-- 收费标准 -->
        <li class="flex05">
          <div class="template">
            <el-input v-model="item.price" size="medium"></el-input>
            <span style="margin-left: 7px;">
              {{ item.unit }}
            </span>
          </div>
        </li>
        <!-- 计费方式 -->
        <li>
          <div class="template">
            <el-radio v-model="item.price_type" :label="0" @change="item.unit = '元'">单价</el-radio>
            <el-radio v-model="item.price_type" :label="1" @change="item.unit = '%'">百分比</el-radio>
          </div>
        </li>
        <!-- 图片 -->
        <li>
          <div>
            <div class="pic-box">
              <div class="img" v-for="(img, imgIndex) in item.image_ext" :key="imgIndex">
                <img :src="img" alt="">
                <div class="btn">
                  <i class="el-icon-zoom-in" @click="handlePictureCardPreview(img)"></i>
                  <i class="el-icon-delete" @click="delLinkPic(index, imgIndex)"></i>
                </div>
              </div>
            </div>
            <!-- 上传图片 -->
            <div class="upPic" @mouseover="setIndex(index)" @click="setIndex(index)">
              <el-upload action="https://jsonplaceholder.typicode.com/posts/" multiple drag :http-request="httpPic"
                :show-file-list="false" accept=".jpg,.jpeg,.png" :limit="6">
                <el-button type="text">{{ $t('message.uoloadPic') }}</el-button>
              </el-upload>
            </div>
          </div>
        </li>
        <!-- 视频 -->
        <li>
          <div>
            <div class="pic-box">
              <div class="img" v-for="(video, videoIndex) in item.video_ext" :key="videoIndex">
                <video :src="video"></video>
                <div class="btn">
                  <i class="el-icon-delete" @click="delLinkVide(index, videoIndex)" style="margin: 0;"></i>
                </div>
              </div>
            </div>
            <!-- 上传视频 -->
            <div class="upPic" @click="setIndex(index)">
              <el-upload action="https://jsonplaceholder.typicode.com/posts/" multiple drag :http-request="httpVideo"
                :show-file-list="false" accept=".MP4" :limit="3">
                <el-button type="text">{{ $t('message.uploadVideo') }}</el-button>
              </el-upload>
            </div>
          </div>
        </li>
        <!-- 文件 -->
        <li>
          <div class="file">
            <div class="item" v-for="(file, fileIndex) in item.file_ext" :key="fileIndex">
              <a :href="file.url" target="_blank" class="a-link word-break" style="text-align: left;">{{ file.name
              }}</a>
              <i class="el-icon-error" @click="delLinkFile(index, fileIndex)"></i>
            </div>
            <!-- 上传文件 -->
            <div class="upPic" @click="setIndex(index)">
              <el-upload action="https://jsonplaceholder.typicode.com/posts/" multiple drag :http-request="httpFile"
                :show-file-list="false" accept=".PDF">
                <el-button type="text">{{ $t('message.upload') }}</el-button>
              </el-upload>
            </div>
          </div>
        </li>
        <!-- 特殊要求 -->
        <li>
          <div class="template">
            <el-input v-model="item.remark_ext" type="textarea">
            </el-input>
          </div>
        </li>
        <!-- 操作 -->
        <li class="flex05">
          <el-button type="text" @click="delItem(index)">{{ $t('message.delete') }}</el-button>
        </li>
      </ul>
    </div>
    <!-- 操作向 -->
    <div class="operation">
      <!-- 选择系统option -->
      <el-button type="primary" class="primary" @click="showOption">{{ $t('message.selectSystemOptions') }}</el-button>
      <!-- 创建自定义option -->
      <el-button type="success" @click="addItem">{{ $t('message.createCustomOptions') }}</el-button>
      <!-- 保存 -->

    </div>
    <!-- 图片放大 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <!-- 选择系统option -->
    <optionTemplate ref="optionTemplate" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import optionTemplate from './optionTemplate.vue'
export default {
  components: { optionTemplate },
  computed: {
    ...mapState(['schedule'])
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogImageUrl: '',
      upIndex: 0,
      detail: {
        option: []
      },
      isUpload: true,
    };
  },
  methods: {
    // 设置数据
    setData(sys_code_set) {
      let datas = {
        user_id: this.detail.user_id,
        sys_code_set: sys_code_set,
        option: JSON.stringify(this.detail.option)
      }
      this.$api.productManagementApi.updateOption(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    // 删除图片
    delLinkPic(index, imgIndex) {
      this.detail.option[index].image_ext.splice(imgIndex, 1)
    },
    // 上传图片
    async httpPic(file) {
      if (this.detail.option[this.upIndex].image_ext.length > 6) return this.$message('最多只能上传6张图片')

      this.loading = true
      let data = await this.createClient(file)
      this.loading = false
      this.detail.option[this.upIndex].image_ext.push(data.data)

    },
    // 删除视频
    delLinkVide(index, videoIndex) {
      this.detail.option[index].video_ext.splice(videoIndex, 1)
    },
    // 上传视频
    async httpVideo(file) {
      if (this.detail.option[this.upIndex].video_ext.length >= 3) return this.$message.error('最多只能上传3个视频')
      this.loading = true
      let data = await this.createClient(file)
      this.loading = false
      this.detail.option[this.upIndex].video_ext.push(data.data)
    },
    // 删除文件
    delLinkFile(index, fileIndex) {
      this.detail.option[index].file_ext.splice(fileIndex, 1)
    },
    // 上传文件
    async httpFile(file) {
      if (this.detail.option[this.upIndex].file_ext.length >= 3) return this.$message.error('最多只能上传3个文件')
      this.loading = true
      let data = await this.createClient(file)
      this.loading = false
      this.detail.option[this.upIndex].file_ext.push({
        name: file.file.name,
        url: data.data
      })
    },
    //删除单条
    delItem(index) {
      this.detail.option.splice(index, 1)
    },
    // 更新option
    updateOption() {
      let datas = {
        user_id: this.detail.user_id,
        sys_code_set: [this.detail.sys_code],
        option: JSON.stringify(this.detail.option)
      }

      this.$api.productManagementApi.updateOption(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //新增单条
    addItem() {
      this.detail.option.push(
        {
          type: "",
          name: "",
          name_translate: "",
          price: "",
          price_type: 0,
          unit: "元",
          is_overstep: 0,
          auto_calculate: 0,
          remark: "",
          icon_selected: "",
          image: "",
          video: "",
          sort: 0,
          num: 1,
          image_ext: [
          ],
          video_ext: [
          ],
          file_ext: [
          ],
          remark_ext: ""
        }
      )
    },
    // 可选的option
    showOption() {
      this.$refs.optionTemplate.dialogVisible = true
    },
    setIndex(index) {
      this.upIndex = index
      // console.log(this.upIndex);

      // if (this.isUpload) {
      //   this.upIndex = index
      //   this.isUpload = false
      //   console.log(index);
      //   setTimeout(() => {
      //     this.isUpload = true
      //   }, 2000)
      // }


    },
  }
}
</script>
<style lang='scss' scoped>
.table {
  li {
    justify-content: left;
    padding: 0 15px;
    position: relative;
  }

  .flex3 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  ol {
    height: 42px;
  }

  ul {
    background-color: #fff;
    min-height: 110px;
    padding: 5px 0;

    .template {
      display: flex;
      line-height: 36px;
    }

    /deep/.el-textarea__inner {
      height: 110px !important;
      width: 100% !important;
    }

    /deep/.el-upload-dragger {
      width: auto;
      height: auto;
      border: none;
    }

  }

  .file {
    width: 100%;

    .item {
      display: flex;
      width: 100%;
      margin-bottom: 10px;

      a {
        margin-right: 12px;
        flex: 1;
      }

      .el-icon-error {
        cursor: pointer;
        font-size: 16px;
        color: #B4272B;
        ;
      }
    }
  }

  .pic-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .img {
      position: relative;
      width: 50px;
      margin-right: 5px;

      &:hover {
        .btn {
          display: flex;
        }
      }

      .btn {
        position: absolute;
        top: 0;
        left: 0;
        width: 50px;
        height: 50px;
        background-color: rgba(0, 0, 0, 0.2);
        display: none;
        justify-content: center;
        align-items: center;
        border-radius: 5px;

        i {
          color: #fff;
          font-size: 16px;
          cursor: pointer;

          &:nth-last-child(1) {
            margin-left: 10px;
          }
        }
      }

      video {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }

      img {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }
    }
  }
}

.operation {
  margin-top: 24px;
}
</style>